export const gridEmpresaFields = [
    { field: 'razao', headerName: 'Razão Social', flex: 1 },
    { field: 'fantasia', headerName: 'Fantasia', flex: 1 },
    { field: 'cnpj', headerName: 'CNPJ', flex: 1 },
    { field: 'ie', headerName: 'Inscrição Estadual', flex: 1 },
    { field: 'acoes' }
];